import React from 'react';
import { StarIcon, CheckCircleIcon } from 'lucide-react';
import { FadeInUp } from './FadeInUp';
const testimonials = [{
  name: 'Carolina M.',
  location: 'Santiago, Chile',
  quote: 'Mi Beagle no paraba de ladrar cuando me iba a trabajar. Los vecinos se quejaban. En solo una semana con el protocolo, ahora se queda durmiendo. Es un milagro.'
}, {
  name: 'Roberto V.',
  location: 'Vitacura, México',
  quote: 'Pensé que mi perro necesitaba correr 2 horas al día. Resulta que 10 minutos de estos ejercicios mentales lo dejan mucho más relajado. Increíble método.'
}, {
  name: 'Valentina S.',
  location: 'Concepción, Chile',
  quote: 'La ansiedad por separación de mi perrita era extrema. Rompía todo. El cambio ha sido brutal, ahora es una perra tranquila y feliz en el departamento.'
}];
export function TestimonialsSection() {
  return <section className="py-24 px-5 max-w-6xl mx-auto bg-zen-beige/30 rounded-[3rem] my-12 pt-[10px] pb-[10px] mt-[28px] mb-[28px]" data-id="element-145">
      <FadeInUp className="pt-[20px] pb-[20px] mt-[10px] mb-[10px]" data-id="element-146">
        <h2 className="text-3xl md:text-5xl font-serif font-bold text-center text-slate-dark mb-16" data-id="element-147">
          Historias de Éxito
        </h2>
      </FadeInUp>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-148">
        {testimonials.map((testimonial, index) => <FadeInUp key={index} delay={index * 0.1} data-id="element-149">
            <div className="bg-white p-8 rounded-3xl shadow-sm hover:shadow-md transition-shadow h-full flex flex-col" data-id="element-150">
              <div className="flex text-yellow-400 mb-6" data-id="element-151">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-152" />)}
              </div>
              <p className="text-slate-dark/80 italic mb-8 flex-grow text-lg leading-relaxed" data-id="element-153">
                "{testimonial.quote}"
              </p>
              <div className="mt-auto pt-6 border-t border-zen-beige" data-id="element-154">
                <p className="font-bold text-slate-dark" data-id="element-155">{testimonial.name}</p>
                <p className="text-sm text-slate-dark/60 mb-3" data-id="element-156">
                  {testimonial.location}
                </p>
                <div className="flex items-center gap-1.5 text-xs font-medium text-slate-dark bg-pistachio/20 inline-flex px-3 py-1 rounded-full" data-id="element-157">
                  <CheckCircleIcon className="w-3.5 h-3.5 text-green-600" data-id="element-158" />
                  Cliente Verificado
                </div>
              </div>
            </div>
          </FadeInUp>)}
      </div>
    </section>;
}